import { useSelectedServiceState } from "@/components/services/servicesStates";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Plus } from "lucide-react";
import ServiceForm from "@/components/services/serviceForm";
import { useState } from "react";

export function RegisterService() {
  const { setSelectedService } = useSelectedServiceState();
  const [isLocalAddServiceOpen, setIsLocalAddServiceOpen] = useState(false);

  return (
    <div>
      <div className="flex h-14 items-center rounded-b-2xl bg-[#16A34A] bg-opacity-40 px-10">
        <h3 className="p-5 font-Hemmers text-3xl text-black">Services</h3>
      </div>
      <div className="py-2">
        <div className="flex items-center justify-between p-4">
          <Dialog
            open={isLocalAddServiceOpen}
            onOpenChange={(open) => {
              setIsLocalAddServiceOpen(open);
              if (!open) {
                setSelectedService(null); // Reset selectedExpense when dialog is closed
              }
            }}
          >
            <DialogTrigger asChild>
              <Button
                onClick={() => {
                  setSelectedService(null);
                }}
                className="gap-x-2 border border-black bg-[#FAFAFA] text-lg text-black hover:bg-gray-200"
              >
                <Plus className="size-4" /> Create New
              </Button>
            </DialogTrigger>
            <DialogContent className="border-transparent bg-inherit">
              <DialogHeader>
                <DialogTitle className="text-black">
                  Create New Service
                </DialogTitle>
                <DialogDescription>
                  Fill in to register a new service
                </DialogDescription>
              </DialogHeader>
              <ServiceForm
                closeDialog={() => setIsLocalAddServiceOpen(false)}
              />
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </div>
  );
}
